import { Box, Group, Pill, Text } from '@mantine/core';

import { CenterReport } from '@/module/ResearchCenter/model/ResearchCenterTypes';

interface CenterReportBoxProps {
  report: CenterReport;
}

export function CenterReportBox({ report }: CenterReportBoxProps) {
  const { title, open } = report;
  return (
    <Box mb="md">
      <Group>
        <Text fw="500">{title}</Text>
        <Pill bg={open ? 'green' : 'red'}>{open ? 'În desfășurare' : 'Raportare finalizată'}</Pill>
      </Group>
    </Box>
  );
}
